var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('keep-alive',{attrs:{"include":_vm.KEEPALIVES}},[_c('router-view')],1),(_vm.showHeader)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }